export default {"src":"/_next/static/media/logo-enterprise.6e7da3ba.svg","height":13,"width":86,"blurWidth":0,"blurHeight":0};